




















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import { inspectService } from "@/service/inspectService.ts";
import requestService from "@/service/requestService";
import { InspectButtonStatus } from "@/model/InspectButtonStatus";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import {
  InspectGensha,
  InspectGenshaCategory,
  InspectGenshaSubItem,
  InspectDescriptions
} from "@/model/InspectGensha";
import { InspectState } from "@/store/modules/inspectStore";
import { SocketControllers } from "@/service/SocketControllers";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import * as util from "@/service/util";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import { CarSelectData } from "@/model/CarSelection";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import { InspectItem, InspectValueItem } from "@/model/InspectItem";
import { Work } from "@/model/Work";
import InspectValueDialog from "@/components/InspectValueDialog.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { INSPECT_VALUE_VIEW_TYPE } from "@/model/InspectValueViewType";
import { InspectLineResult } from "@/model/InspectLineResult";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { InspectRecommendSubItem, InspectRecommendCategory } from "@/model/InspectRecommend";
import { RouteInfo } from "@/model/RouteInfo";

const namespaceInspect = "Inspect";
@Component({
  components: {
    ButtonInspect,
    ButtonInspectGroup,
    SaveDialog,
    ConfirmDialog,
    WorkAndBuhin,
    InputNumber,
    InspectValueDialog
  }
})
export default class InspectionSelections extends Vue {
  inspectType: number = 0;
  data: InspectGensha = {};
  service: inspectService;
  reqService: requestService;
  sktControll: SocketControllers;
  activeCategory: number = 0;
  currentData: InspectGenshaSubItem[] = [];
  loadData: boolean = false;
  errorMsg: string = "";
  headerTopic: string = "";
  apiPath: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  timerSave: any = null;
  timerClick: any = null;
  clickCount: number = 0;
  tempInspect: InspectDescriptions;
  buttonIndex: number = -1;
  activeInspect: any = {};
  activeSubCateIndex: number = -1;
  msgAskChangeInspectResult: string = MESSAGE.AskChangeInspectResult;
  tempBtnIndex: number = -1;
  tempBtnIndexList: number[] = [];
  tempListSave: InspectDescriptions[] = [];
  tempSaveRef: any = {};
  arrStatus: number[] = [];
  isSaving: boolean = false;
  tempListSaving: InspectDescriptions[] = [];
  timerSaving: any = null;
  tempWaitSave: any = [];
  isCallSaveWhenSaving: boolean = false;
  tempDataSave: any = null;
  isSocket: boolean = false;
  inspectList: InspectDescriptions[] = [];
  isOsusume:boolean = false;
  kingakuFlg: boolean = false;
  activeSubCategory: number = 0;
  maxRowNum: number = 0;
  tempOsusumeListSave: InspectRecommendSubItem[] = [];
  tempOsusumeInspect: InspectRecommendSubItem;
  tempIndex: number = -1;
  $refs!: {
    buttonGroup: ButtonInspectGroup[];
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    confirmDialog: ConfirmDialog;
    confirmRegisterDialog: ConfirmDialog;
    workBuhinDialog: WorkAndBuhin;
    cancelDialog: ConfirmDialog;
    osusumeConfirmDialog: ConfirmDialog;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    freeSeibiNotSectingBuhinDialog: ConfirmDialog;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  };

  /** 2021-11-18 sh #7530 improve speed.(No.1) [START] */
  cateLoadingList: any = {};
  /** 2021-11-18 sh #7530 improve speed.(No.1) [END] */
  // 2022-01-31 morisako kobac-free mod [START]
  freeOfChargeNm: string = '無償対応';
  // 2022-01-31 morisako kobac-free mod [END]

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("inspect", { namespace: namespaceInspect })
  inspect!: (index: number) => InspectGensha;
  @Getter("hasData", { namespace: namespaceInspect })
  hasData!: (index: number) => boolean;

  @Action("setInspect", { namespace: namespaceInspect })
  setInspect: any;
  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;
  @Action("setState", { namespace: "CarSelection" })
  setStateCarSelection: any;

  @Action("setState", { namespace: "InspectLine" })
  setState: any;
  @Action("hasData", { namespace: "InspectLine" })
  hasInspectLine: any;

  @Getter("useLine", { namespace: "InspectionDetail" })
  useLine: boolean;
  @Getter("sideSlipValue", { namespace: "InspectLine" })
  sideSlipValue: any;
  @Action("setSideSlip", { namespace: "InspectLine" })
  setSideSlip: any;

  @Getter("inspectLineList", { namespace: "InspectLine" })
  inspectLineList: InspectLineResult[];

  @Action("remove", { namespace: "SeibiIds" })
  removeSeibiId: any;

  /** 2021-12-01 sh #7587 change checking of seibiIds. [START] */
  @Action("setState", { namespace: "SeibiIds" })
  setStateSeibiDetailIds: any;
  /** 2021-12-01 sh #7587 change checking of seibiIds. [END] */

  @Action("setInspectRecommend", { namespace: namespaceInspect })
  setInspectRecommend: any;

  /** 2021-11-19 sh #7530 improve speed.(for back) [START] */
  @Getter("currentState", { namespace: "RouteState" })
  lastSelectedCategoryInfo!: (index: number) => RouteInfo;
  @Getter("hasState", { namespace: "RouteState" })
  hasLastSelectedCategoryInfo!: (index: number) => boolean;

  @Action("setState", { namespace: "RouteState" })
  setRouteInfo: any;
  /** 2021-11-19 sh #7530 improve speed.(for back) [END] */

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.setInspectType(to.name);
    this.currentData = [];
    this.activeCategory = 0;
    this.$set(this, "isSaving", false);
    this.$nextTick(() => {
      this.initPage();
    });
  }

  setInspectType(routeName: string) {
    if (routeName == "legal56") {
      this.inspectType = INSPECT_TYPE.LEGAL56;
      this.headerTopic = "57項目点検内容";
      this.apiPath = "legal56";
    } else if (routeName == "jizen") {
      this.inspectType = INSPECT_TYPE.JIZEN;
      this.headerTopic = "事前見積";
      this.apiPath = "jizen";
    } else {
      this.inspectType = INSPECT_TYPE.GENSHA;
      this.headerTopic = "現車チェック内容";
      this.apiPath = "gensha";
    }
  }

  getPathName(): string {
    if (this.$route.name) {
      return this.$route.name;
    }
    return "";
  }

  created() {
    this.setInspectType(this.getPathName());

    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.service = new inspectService();

    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
    this.sktControll.connectSocket(this.onConnect);
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */

    this.initPage();
  }

  initPage() {
    // 2022-01-31 morisako kobac-free add [START]
    this.reqService.setFreeOfCharge(this.uketsukeExtendsId).then((res: any) => {
      if (res) {
        this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
    this.$emit("onactivepage", this.$route.name);
    this.closeDialogWork();
    // if (this.hasData(this.inspectType)) {
    //   this.data = this.inspect(this.inspectType);
    //   this.setCurrentData();
    //   this.loadData = true;
    // } else {
    this.loadData = false;
    this.loading = false;
    /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
    // this.reqService.getInspect(this.uketsukeExtendsId, this.apiPath).then(
    const promise = this.getInspectPM(this.uketsukeExtendsId, this.apiPath);
    Promise.all(promise).then((val: any) => { // 2021-12-01 sh #7587 change array to object.

        /** 2021-12-01 sh #7587 change check seibiIds. [START] */
        // const res: any = val[0];
        const resSeibiIds: any = val[0];
        const res: any = val[1];

        this.setStateSeibiDetailIds(resSeibiIds);
        /** 2021-12-01 sh #7587 change check seibiIds. [END] */

    /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
        this.loadData = true;
        if (res) {
          if (this.inspectType == INSPECT_TYPE.GENSHA) {
            this.data = { gensha: res.gensha };
            /** 2021-11-08 sh #7530 improve speed.(No.1) [START] */
            /** 残りの点検を取得する */
            if (res.gensha) {
              res.gensha.forEach((items: any) => {
                if (items.subItems && items.subItems.length == 0) {
                  this.getInspectByCategoryId(this.uketsukeExtendsId, this.apiPath, items.sknInspectCategoryId);
                }
              });
              /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
              this.changeCategoryByLastSelected(res.gensha.length);
              /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
            }
            /** ひとまず、現車だけ入れて試してみる */
            /** 2021-11-08 sh #7530 improve speed.(No.1) [END] */
          } else if (this.inspectType == INSPECT_TYPE.JIZEN) {
            this.data = { jizen: res.jizen };
            /** 2021-11-18 sh #7530 improve speed.(No.1) [START] */
            /** 残りの点検を取得する */
            if (res.jizen) {
              res.jizen.forEach((items: any) => {
                /** おすすめではない、事前見積を取得する。 */
                if (items.osusume == false && items.subItems && items.subItems.length == 0) {
                  this.getInspectByCategoryId(this.uketsukeExtendsId, this.apiPath, items.sknInspectCategoryId);
                }
              });
              /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
              this.changeCategoryByLastSelected(res.jizen.length);
              /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
            }
            /** 2021-11-18 sh #7530 improve speed.(No.1) [END] */
          } else {
            this.data = { legal56: res.legal56 };
            /** 2021-11-18 sh #7530 improve speed.(No.1) [START] */
            /** 残りの点検を取得する */
            if (res.legal56) {
              res.legal56.forEach((items: any) => {
                if (items.subItems && items.subItems.length == 0) {
                  this.getInspectByCategoryId(this.uketsukeExtendsId, this.apiPath, items.sknInspectCategoryId);
                }
              });
              /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
              this.changeCategoryByLastSelected(res.legal56.length);
              /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
            }
            /** 2021-11-18 sh #7530 improve speed.(No.1) [END] */
          }

          this.setProgressState({
            stateId: res.sknWorkProgressStateId,
            stateNm: res.sknWorkProgressStateNm
          });
          if (this.data[this.apiPath]) {
            this.addStatus();
            // this.setSideSlipData(this.data[this.apiPath][0]);
            this.$set(this, "isSaving", false);
          }
        }
      },
      (err: any) => {
        this.loadData = true;
        this.onError(err);
      }
    );
    // }
    // 2022-01-31 morisako kobac-free add [START]
      }
    });
    // 2022-01-31 morisako kobac-free add [END]
  }

  /** 2021-11-19 sh #7530 improve speed.(for back) [START] */
  getInspectPM(uketsukeExtendsId: any, apiPath: any) {
    let promise;
    if (this.hasLastSelectedCategoryId()) {
      /** 「戻る」ボタンで戻った場合、最後に開いていたカテゴリを開く。 */
      let sknInspectCategoryId: any = this.getLastSelectedCategoryId();
      promise = new Promise((resolve, reject) => {
        this.reqService.getInspectByCategoryId(uketsukeExtendsId, apiPath, sknInspectCategoryId).then(
          (res: any) => {
            resolve(res);
        }, (err: any) => reject(err));
      });
    } else {
      /** 初めてアクセスする場合 */
      promise = new Promise((resolve, reject) => {
        this.reqService.getInspect(uketsukeExtendsId, apiPath).then(
          (res: any) => {
            resolve(res);
        }, (err: any) => reject(err));
      });
    }

    /** 2021-12-01 sh #7587 change check seibiIds. [START] */
    const promiseSeibiIds = this.getSelectingSeibiIdsPM(uketsukeExtendsId);
    // return promise;
    return [promiseSeibiIds, promise];
    /** 2021-12-01 sh #7587 change check seibiIds. [END] */
  }

  /** 2021-12-01 sh #7587 change check seibiIds. [START] */
  getSelectingSeibiIdsPM(uketsukeExtendsId: any) {
    const promiseSeibiIds = new Promise((resolve, reject) => {
      this.reqService.getSelectingSeibiIds(uketsukeExtendsId).then((res: any) => {
          /** 取得したseibiIdのリストを保存する */
          resolve(res);
      }, (err: any) => {
        if (err && err.status && err.status == 204) {
          resolve([]);
        } else {
          reject(err);
        }
      });
    });
    return promiseSeibiIds;
  }
  /** 2021-12-01 sh #7587 change check seibiIds. [END] */

  hasLastSelectedCategoryId() {
    return this.hasLastSelectedCategoryInfo(this.inspectType);
  }

  getLastSelectedCategoryId() {
    let sknInspectCategoryId: any;
    if (this.hasLastSelectedCategoryId()) {
      let lastCategoryInfo: RouteInfo = this.lastSelectedCategoryInfo(this.inspectType);
      if (lastCategoryInfo && lastCategoryInfo.sknInspectCategoryId) {
        sknInspectCategoryId = lastCategoryInfo.sknInspectCategoryId;
      }
    }
    return sknInspectCategoryId;
  }

  getLastSelectedPos() {
    let pos: number = -1;
    if (this.hasLastSelectedCategoryId()) {
      let lastCategoryInfo: RouteInfo = this.lastSelectedCategoryInfo(this.inspectType);
      if (lastCategoryInfo && lastCategoryInfo.pos !=null) {
        pos = lastCategoryInfo.pos;
      }
    }
    return pos;
  }

  getLastSelectedSubPos() {
    let pos: number = -1;
    if (this.hasLastSelectedCategoryId()) {
      let lastCategoryInfo: RouteInfo = this.lastSelectedCategoryInfo(this.inspectType);
      if (lastCategoryInfo && lastCategoryInfo.subPos !=null) {
        pos = lastCategoryInfo.subPos;
      }
    }
    return pos;
  }

  posToSknInspectCategoryId(pos: any) {
    let sknInspectCategoryId: any;
    let cnt = 0;
    this.data[this.apiPath].forEach((cate: any) => {
      if (cate && cate.sknInspectCategoryId && cnt == pos) {
        sknInspectCategoryId = cate.sknInspectCategoryId;
      }
      cnt++;
    });
    return sknInspectCategoryId;
  }

  changeCategoryByLastSelected(length: number) {
    if (this.hasLastSelectedCategoryId()){
      const pos = this.getLastSelectedPos()
      if (pos > -1 && length > pos) {
        this.changeCategory(Number(pos));
        if (this.inspectType == INSPECT_TYPE.JIZEN) {
          const subPos = this.getLastSelectedSubPos();
          if ( subPos > 0) {
            this.changeSubCategory(subPos);
          }
        }
      }
    /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [START] */
    } else {
      setTimeout(()=> {
        this.scrollToFirstIncomplete();
      }, 100);
    /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [END] */
    }
  }
  /** 2021-11-19 sh #7530 improve speed.(for back) [END] */

  addStatus() {
    let promise = this.data[this.apiPath].map((cate: any) => {
      let nItem = 0;
      let sumStatus = 0;
      if (!cate.osusume) {
      cate.subItems.forEach((item: InspectGenshaSubItem, i: any) => {
        nItem += item.inspectDescriptions.length;
        item.inspectDescriptions = item.inspectDescriptions.map(
          (obj: InspectDescriptions) => {
            if (obj.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
              obj.seibiList.forEach(seibi => {
                if (seibi.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
                  let _list = item.inspectDescriptions.filter(
                    inspect =>
                      inspect.sknInspectDescriptionId !=
                      obj.sknInspectDescriptionId
                  );
                  if (
                    obj.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE
                  ) {
                    let subCatIndex = 0;
                    if (i == 0) {
                      subCatIndex = 1;
                    }
                    _list = _list.concat(
                      cate.subItems[subCatIndex].inspectDescriptions
                    );
                  }
                  this.service.autoSetDuplicateSeibi(
                    _list,
                    seibi,
                    (inspectChanged: any, index: number) => {
                      item.inspectDescriptions[index].status =
                        InspectButtonStatus.COMPLETED;
                      item.inspectDescriptions[index].workBuhinSelected =
                        inspectChanged.workBuhinSelected;
                    }
                  );
                }
              });
            }
            this.changeStatus(obj, false, true);
            if (obj.status) {
              sumStatus += obj.status;
            }
            return {
              ...obj,
              showWork: false,
              showValue: false,
              isSaving: false
            };
          }
        );
      });
      this.setCateStatus(sumStatus, nItem, cate);
      } else {
        cate.recommend.forEach((subCate: any, i: any) => {
          let recommendSumStatus = 0;
          let recommendNItem = 0;
          subCate.subItems.forEach((item: any, i: any) => {
            if (item.osusumeIsShow == 1) {
              recommendNItem += 1;
              /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
              // if (item.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
              if (item.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done || item.buhinSelected == STATUS_SELECT_WORK_BUHIN.NoNeed) {
              /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
                recommendSumStatus += item.buhinSelected;
                item.status = InspectButtonStatus.COMPLETED;
              } else {
                item.status = InspectButtonStatus.INCOMPLETE;
              }
            }
          });
          this.setOsusumeCateStatus(recommendSumStatus, recommendNItem, subCate);
        });
      }
      return cate;
    });
    Promise.all(promise).then((res: any) => {
      // console.log("Promise.all", res);
      this.$set(this.data, this.apiPath, res);
      this.setCurrentData(false);
      this.setInspect({ data: this.data, index: this.inspectType });
    });
  }

  setDataFromMD3(cate: InspectGenshaCategory) {
    if (this.inspectType == INSPECT_TYPE.GENSHA) {
      if (this.carSelection.jidoushaShubetsu) {
        if (cate.sknInspectCategoryNm.trim() == "足廻り･ﾀｲﾔ") {
          cate.subItems.forEach(item => {
            item.inspectDescriptions.forEach(inspect => {
              let listVal = [] as InspectValueItem[];
              if (
                inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE
              ) {
                listVal.push({
                  branchId: 1,
                  inspectValue: this.carSelection.fLeftTireNokorimizo
                });
                listVal.push({
                  branchId: 2,
                  inspectValue: this.carSelection.fRightTireNokorimizo
                });
                listVal.push({
                  branchId: 3,
                  inspectValue: this.carSelection.rLeftTireNokorimizo
                });
                listVal.push({
                  branchId: 4,
                  inspectValue: this.carSelection.rRightTireNokorimizo
                });
                let doSave = true;
                if (inspect.inspectValueList) {
                  const values = inspect.inspectValueList
                    .map((e: any) => e.inspectValue)
                    .join();
                  const newValues = listVal
                    .map((e: any) => e.inspectValue)
                    .join();
                  if (values === newValues) {
                    doSave = false;
                  }
                }
                if (doSave) {
                  this.onConfirmValue(listVal, inspect, false);
                }
              }
            });
          });
        } else if (cate.sknInspectCategoryNm.trim() == "ﾎﾞﾃﾞｨ･現状") {
          //sknSaiteiChijouKou 1 ok, 2 ng
          for (let i = 0; i < cate.subItems.length; i++) {
            const inspect = cate.subItems[i].inspectDescriptions.find(
              inspect => inspect.sknInspectDescriptionNm.trim() == "地上最低高"
            );
            if (inspect) {
              if (
                inspect.inspectResult == 0 &&
                this.carSelection.sknSaiteiChijouKou
              ) {
                inspect.inspectResult = this.carSelection.sknSaiteiChijouKou;
                this.saveInspectItem(inspect);
              }
              break;
            }
          }
        } else if (
          cate.sknInspectCategoryNm.trim() == "車内点検" &&
          this.carSelection.meterPanelAlert
        ) {
          const list = [
            "前方ｴｱﾊﾞｯｸﾞ警告灯",
            "側方ｴｱﾊﾞｯｸﾞ警告灯",
            "ﾌﾞﾚｰｷ警告灯",
            "ABS警告灯",
            "ｴﾝｼﾞﾝ警告灯"
          ];
          const subCateIndex = cate.subItems.length - 1;
          const inspectList = cate.subItems[
            subCateIndex
          ].inspectDescriptions.filter(
            inspect => list.indexOf(inspect.sknInspectDescriptionNm.trim()) > -1
          );
          if (inspectList.length > 0) {
            const promise = inspectList.map((inspect, i: number) => {
              if (!inspect.inspectResult) {
                let result = InspectButtonValue.CIRCLE;
                if (this.carSelection.meterPanelAlert == 2) {
                  result = InspectButtonValue.CROSS;
                }
                inspect.inspectResult = result;
                this.saveInspectItem(inspect);
              }
            });

            Promise.all(promise).then(() => {
              this.$forceUpdate();
            });
          }
        }
      } else {
        this.reqService
          .getCarSelection(this.uketsukeExtendsId)
          .then((res: any) => {
            res.sknUketsukeExtendsId = this.uketsukeExtendsId;
            this.setStateCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
            this.setDataFromMD3(cate);
          });
      }
    } else if (this.inspectType == INSPECT_TYPE.JIZEN && cate.subItems) { // 2021-10-07 sh add condition
      cate.subItems.forEach(item => {
        item.inspectDescriptions.forEach(inspect => {
          let listVal = [] as InspectValueItem[];
          if (inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
            listVal.push({
              branchId: 1,
              inspectValue: this.carSelection.fLeftTireNokorimizo
            });
            listVal.push({
              branchId: 2,
              inspectValue: this.carSelection.fRightTireNokorimizo
            });
            listVal.push({
              branchId: 3,
              inspectValue: this.carSelection.rLeftTireNokorimizo
            });
            listVal.push({
              branchId: 4,
              inspectValue: this.carSelection.rRightTireNokorimizo
            });
            let doSave = true;
            if (inspect.inspectValueList) {
              const values = inspect.inspectValueList
                .map((e: any) => e.inspectValue)
                .join();
              const newValues = listVal
                .map((e: any) => e.inspectValue)
                .join();
              if (values === newValues) {
                doSave = false;
              }
            }
            if (doSave) {
              this.onConfirmValue(listVal, inspect, false);
            }
          } else if (inspect.sknInspectDescriptionNm.trim() == "地上最低高") {
            if (inspect.inspectResult == 0 && this.carSelection.sknSaiteiChijouKou) {
              inspect.inspectResult = this.carSelection.sknSaiteiChijouKou;
              this.saveInspectItem(inspect);
            }
          } else if ((inspect.sknInspectDescriptionNm.trim() == "前方ｴｱﾊﾞｯｸﾞ警告灯"
            || inspect.sknInspectDescriptionNm.trim() == "側方ｴｱﾊﾞｯｸﾞ警告灯"
            || inspect.sknInspectDescriptionNm.trim() == "ﾌﾞﾚｰｷ警告灯"
            || inspect.sknInspectDescriptionNm.trim() == "ABS警告灯"
            || inspect.sknInspectDescriptionNm.trim() == "ｴﾝｼﾞﾝ警告灯")
            && this.carSelection.meterPanelAlert) {
            if (!inspect.inspectResult) {
              let result = InspectButtonValue.CIRCLE;
              if (this.carSelection.meterPanelAlert == 2) {
                result = InspectButtonValue.CROSS;
              }
              inspect.inspectResult = result;
              this.saveInspectItem(inspect);
              this.$forceUpdate();
            }
          }
        });
      });
    } else if (this.inspectType == INSPECT_TYPE.LEGAL56 && cate.subItems) {
      if (
        cate.sknInspectCategoryNm.trim() == "車載式故障診断装置点検" &&
        this.carSelection.meterPanelAlert
      ) {
        const list = [
          "前方ｴｱﾊﾞｯｸﾞ警告灯",
          "側方ｴｱﾊﾞｯｸﾞ警告灯",
          "ﾌﾞﾚｰｷ警告灯",
          "ABS警告灯",
          "ｴﾝｼﾞﾝ警告灯",
          "自動ﾌﾞﾚｰｷ",
          "ﾚｰﾝｷｰﾌﾟ",
          "自動運行装置"
        ];
        const subCateIndex = cate.subItems.length - 1;
        const inspectList = cate.subItems[
          subCateIndex
        ].inspectDescriptions.filter(
          inspect => list.indexOf(inspect.sknInspectDescriptionNm.trim()) > -1
        );
        if (inspectList.length > 0) {
          const promise = inspectList.map((inspect, i: number) => {
            if (!inspect.inspectResult) {
              let result = InspectButtonValue.CIRCLE;
              if (this.carSelection.meterPanelAlert == 2) {
                result = InspectButtonValue.CROSS;
              }
              inspect.inspectResult = result;
              this.saveInspectItem(inspect);
            }
          });

          Promise.all(promise).then(() => {
            this.$forceUpdate();
          });
        }
      }
    }
  }

  setSideSlipData(cate: InspectGenshaCategory) {
    if (
      this.inspectType == INSPECT_TYPE.LEGAL56 &&
      this.useLine &&
      this.sideSlipValue != null
    ) {
      cate.subItems.forEach(item => {
        item.inspectDescriptions.forEach(inspect => {
          let listVal = [] as InspectValueItem[];
          if (
            inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP
          ) {
            if (
              !inspect.inspectValueList ||
              inspect.inspectValueList.length == 0 ||
              inspect.inspectValueList[0].inspectValue != this.sideSlipValue
            ) {
              listVal.push({
                branchId: 1,
                inspectValue: this.sideSlipValue
              });
              this.onConfirmValue(listVal, inspect, true, false);
            }
          }
        });
      });
    }
  }

  setCurrentData(gotop: boolean = true) {
    if (this.data[this.apiPath]) {
      if (this.data[this.apiPath][this.activeCategory].osusume) {
        this.$set(this, "isOsusume", true);
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        /**
        const currentData = Array.from(
          this.data[this.apiPath][this.activeCategory].recommend[this.activeSubCategory].subItems
        );
        this.$set(this, "currentData", currentData);
        **/
        this.setOsusumeCurrentData();
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      } else {
        this.$set(this, "isOsusume", false);
      this.loadData = true;
      const currentData = Array.from(
        this.data[this.apiPath][this.activeCategory].subItems
      );
      this.$set(this, "currentData", currentData);
      }
      this.setDataFromMD3(this.data[this.apiPath][this.activeCategory]);
      /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [START] */
      // setTimeout(() => {
      //  this.scrollToFirstIncomplete();
      //}, 100);
      if (gotop) {
        setTimeout(() => {
          this.scrollToFirstIncomplete();
        }, 100);
      }
      /** 2021-11-25 sh #7530 fix call scrollToFirstIncomplete. [END] */
    }
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Watch("activeCategory")
  onChangeActiveCategory() {
    if (this.loadData) {
      setTimeout(()=>{
        this.checkIsFreeSeibiDoesNotSelectingBuhin();
      }, 100);
    }
  }

  @Watch("loadData")
  onChangeLoadData() {
    if (this.loadData) {
      setTimeout(()=>{
        this.checkIsFreeSeibiDoesNotSelectingBuhin();
      }, 2000);
    }
  }

  checkIsFreeSeibiDoesNotSelectingBuhin() {
    if (this.currentData && this.currentData.length > 0) {
      let isFreeSeibiDoesNotSelectingBuhin = false;
      this.currentData.forEach((item :any) => {
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
        // item.inspectDescriptions.forEach((inspect: any) => {
        //   if (inspect.seibiList) {
        //     const freeSeibiDoesNotSelectingBuhin = inspect.seibiList.filter((seibi :any) =>
        //       seibi.buhinSelected == 0 && seibi.discountWorkSelected == 1 && seibi.freeOfChargeBuhinList && seibi.freeOfChargeBuhinList.length > 1
        //     );
        //     if (freeSeibiDoesNotSelectingBuhin && freeSeibiDoesNotSelectingBuhin.length > 0) {
        //       isFreeSeibiDoesNotSelectingBuhin = true;
        //     }
        //   }
        // });
        if (item.inspectDescriptions && item.inspectDescriptions.length > 0) {
          item.inspectDescriptions.forEach((inspect: any) => {
            if (inspect.seibiList) {
              const freeSeibiDoesNotSelectingBuhin = inspect.seibiList.filter((seibi :any) =>
                seibi.buhinSelected == 0 && seibi.discountWorkSelected == 1 && seibi.freeOfChargeBuhinList && seibi.freeOfChargeBuhinList.length > 1
              );
              if (freeSeibiDoesNotSelectingBuhin && freeSeibiDoesNotSelectingBuhin.length > 0) {
                isFreeSeibiDoesNotSelectingBuhin = true;
              }
            }
          });
        }
        /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
      });
      if (isFreeSeibiDoesNotSelectingBuhin) {
        this.$refs.freeSeibiNotSectingBuhinDialog.onOpen();
      }
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  getIndex(parent: number, child: number) {
    let res = 0;
    for (let i = 0; i < parent; i++) {
      res += this.currentData[i].inspectDescriptions.length;
    }
    return res + child;
  }

  isActive(i: number) {
    return this.activeCategory == i;
  }

  // onCheckAll(index: number, data: { isActive: boolean; value: number }) {
  //   const start = this.getIndex(index, 0);
  //   const end = start + this.currentData[index].inspectDescriptions.length - 1;
  //   let c = 0;
  //   for (let i = start; i <= end; i++) {
  //     let buttongroup = this.$refs.buttonGroup[i] as ButtonInspectGroup;
  //     const isChange = buttongroup.setActive({
  //       isActive: data.isActive,
  //       value: data.value,
  //       isAll: true
  //     });
  //     if (isChange) {
  //       this.saveInspectItem(this.currentData[index].inspectDescriptions[c]);
  //     }
  //     c++;
  //   }
  // }
  onCheckAll(index: number, data: { isActive: boolean; value: number }) {
    const start = this.getIndex(index, 0);
    const end = start + this.currentData[index].inspectDescriptions.length - 1;
    // let c = 0;
    let nChange = 0;
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
    let objForSave: any = [];
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
    for (let i = start; i <= end; i++) {
      let buttongroup = this.$refs.buttonGroup[i] as ButtonInspectGroup;
      const isChange = buttongroup.setActive({
        isActive: data.isActive,
        value: data.value,
        isAll: true
      });
      if (isChange) {
        nChange++;
      }
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
      objForSave.push({item: this.currentData[index].inspectDescriptions[i-start], isChange: isChange});
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
      // if (isChange) {
      //   this.saveInspectItem(this.currentData[index].inspectDescriptions[c]);
      // }
      // c++;
    }
    if (nChange > 0) {
      this.activeSubCateIndex = index;
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
      // this.saveSubItem(this.currentData[index]);
      this.saveSubItem(objForSave, index);
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
    }
  }

  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
  /**
  saveCurrentData() {
    let objForSave: InspectGenshaSubItem[] = util.deepCopy(this.currentData);
    let arrInspect: any = [];
    const promise = objForSave.map(
      (item: InspectGenshaSubItem, iSubcate: number) => {
        item.inspectDescriptions.map(
          (inspect: InspectDescriptions, iItem: number) => {
            this.keepInspectRef(inspect, iSubcate, iItem);
            arrInspect.push(this.removeInspectParam(inspect, false));
            return inspect;
          }
        );
        return item;
      }
    );
    Promise.all(promise).then(() => {
      this.callAPISaveMultipleItems(arrInspect);
    });
  }
  */
  saveCurrentData(objForSave: any) {
    let arrInspect: any = [];
    const promise = objForSave.map(
      (obj: any[], iSubcate: number) => {
        if (obj[0] && obj[0].length > 0) {
          obj[0].map(
            (data: any, iItem: number) => {
              let inspect = data.item;
              if (data.isChange) {
                this.keepInspectRef(inspect, iSubcate, iItem);
                /** コピーモードで、呼び出す。オリジナルで処理させると、seibiListが消え、おかしなことになる。 */
                arrInspect.push(this.removeInspectParam(inspect, true));
              }
              return data;
            }
          );
          return obj;
        }
      }
    );
    Promise.all(promise).then(() => {
      this.callAPISaveMultipleItems(arrInspect);
    });
  }

  setActiveForPassAllCategory(index: number) {
    let promise = new Promise((resolve, reject) => {
      const start = this.getIndex(index, 0);
      const end = start + this.currentData[index].inspectDescriptions.length - 1;
      let objForSave: any = [];
      for (let i = start; i <= end; i++) {
        let buttongroup = this.$refs.buttonGroup[i] as any;
        const isChange = buttongroup.setActive({
          isActive: true,
          value: InspectButtonValue.CIRCLE,
          isAll: true
        });
        /** ここで、変更だけにすると、keepInspectRefで、位置を覚えるときに、ズレてしまうので、全ての結果を返すようにする。*/
        /** 変更だけで、絞り込むのは、keepInspectRefを呼ぶタイミングにする。*/
        objForSave.push({item: this.currentData[index].inspectDescriptions[i-start], isChange: isChange});
      }
      resolve([objForSave, index]);
    });
    return promise;
  }
  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */

  removeInspectParam(inspectItem: InspectDescriptions, copy: boolean = true) {
    this.setSaving(inspectItem.sknInspectDescriptionId);
    let objForSave = {} as InspectDescriptions;
    if (copy) {
      objForSave = util.deepCopy(inspectItem);
    } else {
      objForSave = inspectItem;
    }
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.showValue;
    delete objForSave.isSaving;
    // objForSave.inspectResult = 0;
    if (objForSave.inspectResult == InspectButtonValue.CIRCLE) {
      let oldWorkBuhinSelected = objForSave.workBuhinSelected;
      objForSave.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      if (oldWorkBuhinSelected == 0) {
        objForSave.seibiList = [];
      } else {
        if (objForSave.manualSeibiList.length > 0) {
          const manualSeibiList = util.deepCopy(objForSave.manualSeibiList);
          objForSave.manualSeibiList = [];
          manualSeibiList.forEach((seibi: any) => {
            const id: any = seibi.seibiId;
            this.reqService.deleteManualSeibi({
              sknUketsukeManualSeibiId: id,
              uketsukeExtendsId: this.uketsukeExtendsId
            });
            // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
            delete seibi.disabledSave;
            // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
            return seibi;
          });
        }
        const subCateIndex = this.activeSubCateIndex;
        objForSave.seibiList.forEach((seibi: Work) => {
          const buhinSelected = seibi.buhinSelected;
          seibi.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
          if (
            buhinSelected === STATUS_SELECT_WORK_BUHIN.Done &&
            !seibi.disabledSave
          ) {
            let listInspect = this.currentData[
              subCateIndex
            ].inspectDescriptions.filter(
              inspect =>
                inspect.sknInspectDescriptionId !=
                objForSave.sknInspectDescriptionId
            );
            this.service.autoSetDuplicateSeibi(listInspect, seibi);
          }

          if (seibi.manualBuhinList.length > 0) {
            seibi.manualBuhinList.forEach(buhin => {
              if (buhin.buhinId) {
                this.reqService.deleteManualBuhin(buhin.buhinId);
              }
              /** 2022-08-05 sh #8018(BQR1031) add isDelete to manual's buhin. [START] */
              if (buhin.id) {
                buhin.isDelete = 1;
              }
              /** 2022-08-05 sh #8018(BQR1031) add isDelete to manual's buhin. [END] */
            });
          }
          if (seibi.buhinList.length > 0) {
            seibi.buhinList.forEach(buhin => {
              if (buhin.id) {
                buhin.isDelete = 1;
              }
            });
          }
        });
      }
    }

    /** 2021-12-01 sh #7587 change check seibiIds. [START] */
    /** FakeDoneは、共通の整備が他で、選択済みな状態。保存するときは、Doneにする。 */
    if (objForSave.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.FakeDone) {
       objForSave.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
     }
    /** 2021-12-01 sh #7587 change check seibiIds. [END] */
    for (let i = objForSave.seibiList.length - 1; i >= 0; i--) {
      if (
        objForSave.seibiList[i].buhinSelected ==
          STATUS_SELECT_WORK_BUHIN.Initial &&
        objForSave.seibiList[i].seibiId == null
      ) {

        objForSave.seibiList.splice(i, 1);
      } else {
        if (objForSave.seibiList[i].disabledSave) {
          /** 2021-09-09 sh #7393 if it has seibi of recommend that it does not link to inspect, save it. [START] */
          // objForSave.seibiList.splice(i, 1);
          if (objForSave.sknUketsukeInspectId == null && objForSave.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
            /** 2021-11-29 sh #7579 if gensha or legal57, run 'splice'. [START] */
            /** 点検と紐づいていない整備が選択済みだった場合、おすすめ整備となるので、削除せずに紐づけてあげる */
            // delete objForSave.seibiList[i].disabledSave;
            if (objForSave.seibiList[i].sknInspectType == INSPECT_TYPE.GENSHA || objForSave.seibiList[i].sknInspectType == INSPECT_TYPE.LEGAL56) {
              objForSave.seibiList.splice(i, 1);
            } else {
              delete objForSave.seibiList[i].disabledSave;
            }
            /** 2021-11-29 sh #7579 if gensha or legal57, run 'splice'. [END] */
          } else {
            objForSave.seibiList.splice(i, 1);
          }
          /** 2021-09-09 sh #7393 if it has seibi of recommend that it does not link to inspect, save it. [END] */
        } else {
          const buhinList = objForSave.seibiList[i].buhinList.filter(
            buhin => buhin.quantity > 0
          );
          objForSave.seibiList[i].buhinList = buhinList;
          if (objForSave.seibiList[i].hasOwnProperty("disabledSave")) {
            delete objForSave.seibiList[i].disabledSave;
          }
          if (objForSave.seibiList[i].hasOwnProperty("ignoreSeibi")) {
            delete objForSave.seibiList[i].ignoreSeibi;
          }
        }
      }
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    if (objForSave.manualSeibiList.length > 0) {
      objForSave.manualSeibiList.forEach((seibi: any) => {
        delete seibi.disabledSave;
        return seibi;
      });
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    return objForSave;
  }

  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
  /**
//  saveSubItem(subItem: InspectGenshaSubItem) {
//    let subItemForSave = util.deepCopy(subItem);
//    let items: any = [];
//    // if (
//    //   subItemForSave.inspectDescriptions.every(
//    //     (item: any) => item.status == InspectButtonStatus.INCOMPLETE
//    //   )
//    // ) {
//    //   return false;
//    // }
//    subItemForSave.inspectDescriptions.forEach(
//      (inspect: InspectDescriptions, i: number) => {
//        this.keepInspectRef(inspect, this.activeSubCateIndex, i);
//        items.push(this.removeInspectParam(inspect, false));
//        // this.removeFromNotSavedList(inspect);
//      }
//    );
//    if (items.length > 0) {
//      if (this.tempListSave.length > 0) {
//        this.clearTimerSave();
//        items = [...items, ...this.tempListSave];
//      }
//      this.callAPISaveMultipleItems(items, false);
//    }
//  }
  */
  saveSubItem(subItems: any[], subCateIndex: any = this.activeSubCateIndex) {
    let subItemForSave = util.deepCopy(subItems);
    let items: any = [];

    const promise = subItemForSave.map(
      (data: any, i: number) => {
        let inspect: InspectDescriptions = data.item;
        if (data.isChange) {
          this.keepInspectRef(inspect, subCateIndex, i);
          items.push(this.removeInspectParam(inspect, false));
        }
        return data;
      }
    );
    Promise.all(promise).then(() => {
      if (items.length > 0) {
        if (this.tempListSave.length > 0) {
          this.clearTimerSave();
          items = [...items, ...this.tempListSave];
        }
        this.callAPISaveMultipleItems(items, false);
      }
    });
  }
  /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */

  callAPISaveMultipleItems(items: any, updateData: boolean = true) {
    if (this.isSaving) {
      if (this.tempWaitSave == null) {
        this.tempWaitSave = [];
      }
      this.tempWaitSave = [...this.tempWaitSave, ...items];
      this.isCallSaveWhenSaving = true;
    } else {
      this.isSaving = true;
      let data: any = {};
      data[this.apiPath] = [
        {
          subItems: [
            {
              inspectDescriptions: items
            }
          ]
        }
      ];
      this.reqService.saveInspect(data, this.apiPath).then(
        (res: any) => {
          this.$set(this, "isSaving", false);
          this.arrStatus = [];
          if (res && res.body && res.body[this.apiPath]) {
            this.isSocket = true;
            this.updateInspectList(res.body, true);
            if (this.isCallSaveWhenSaving) {
              this.isCallSaveWhenSaving = false;
              if (this.tempWaitSave) {
                this.callAPISaveMultipleItems(this.tempWaitSave, updateData);
                this.tempWaitSave = null;
              }
            } else {
              this.tempListSave = [];
              // if (updateData) {
              //   this.data = res.body;
              //   this.addStatus();
              // }
            }
          }
        },
        error => {
          this.$set(this, "isSaving", false);
          console.error("error", error);
          this.$notify.error({
            title: "エラー",
            message: data[this.apiPath][0].subItems[0].sknInspectCategoryNm
          });
          this.tempListSave = [];
          this.arrStatus = [];
          this.initPage();
        }
      );
    }
  }

  // removeFromNotSavedList(inspectItem: InspectDescriptions) {
  //   let indexNotSaved = this.listNotSavedId.indexOf(
  //     inspectItem.sknInspectDescriptionId
  //   );
  //   if (indexNotSaved > -1) {
  //     this.listNotSavedId.splice(indexNotSaved, 1);
  //   }
  // }

  getIsSocket() {
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [START] */
    // return this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    let isSocket = this.arrStatus.indexOf(InspectButtonStatus.COMPLETED) > -1 ? 1 : 0;
    if (isSocket == 0) {
      if (this.activeInspect && this.activeInspect.buhinList) {
        if (this.activeInspect.buhinList.length == 0 || this.activeInspect.buhinList.length == 1) {
          isSocket = 1;
        }
      }
      if (this.activeInspect && this.activeInspect.osusumeBuhinList) {
        if (this.activeInspect.osusumeBuhinList.length == 0 || this.activeInspect.osusumeBuhinList.length == 1) {
          isSocket = 1;
        }
      }
    }
    return isSocket;
    /** 2024-01-24 sh #8725(BQRxxx) お奨め整備の金額が赤画面に反映されない (No.5) [END] */
  }

  getObjForSave(apiPath: string) {
    let data: any = {};
    data[apiPath] = [
      {
        subItems: [
          {
            inspectDescriptions: util.deepCopy(this.tempListSave)
          }
        ]
      }
    ];
    return data;
  }

  saveInspectItem(inspectItem: InspectDescriptions) {
    let objForSave: InspectDescriptions = this.removeInspectParam(inspectItem);
    if (this.isSaving) {
      // this.tempWaitSave = util.deepCopy(inspectItem);
      // this.timerSaving = setTimeout(() => {
      //   this.saveInspectItem(inspectItem);
      // }, 1000);
      if (this.tempWaitSave == null) {
        this.tempWaitSave = [];
      }
      this.tempWaitSave.push(objForSave);
      this.isCallSaveWhenSaving = true;
      return;
    } else {
      this.tempWaitSave = null;
    }
    // if (inspectItem.status == InspectButtonStatus.COMPLETED || forceSave) {
    this.clearTimerSave();
    // this.removeFromNotSavedList(inspectItem);
    let index = -1;
    index = this.tempListSave.findIndex(
      inspect =>
        inspect.sknInspectDescriptionId == objForSave.sknInspectDescriptionId
    );
    if (index > -1) {
      this.tempListSave.splice(index, 1);
    }
    this.arrStatus.push(inspectItem.status || 0);
    this.tempListSave.push(objForSave);
    this.saveSknSaiteiChijouKou(inspectItem);
    this.callAPISave(inspectItem);
  }

  callAPISave(inspectItem: InspectDescriptions) {
    let apiPath = this.apiPath;
    this.timerSave = setTimeout(() => {
      if (this.tempListSave.length > 0) {
        const isOneSocket = this.tempListSave.length > 1;
        let data: any = this.getObjForSave(apiPath);
        this.isSaving = true;
        this.tempListSaving = util.deepCopy(this.tempListSave);
        this.tempListSave = [];
        this.arrStatus = [];
        this.reqService.saveInspect(data, apiPath).then(
          (res: any) => {
            if (res.status == 200 && res.body && res.body[this.apiPath]) {
              /** 2021-12-01 sh #7587 change check seibiIds. [START] */
              const promise = this.getSelectingSeibiIdsPM(this.uketsukeExtendsId);
              Promise.all([promise]).then((val: any) => {
                const resSeibiIds: any = val[0];
                this.setStateSeibiDetailIds(resSeibiIds);
              });
              /** 2021-12-01 sh #7587 change check seibiIds. [END] */
              this.$set(this, "isSaving", false);
              this.updateInspectList(res.body, isOneSocket);
              if (this.isCallSaveWhenSaving) {
                this.isCallSaveWhenSaving = false;
                if (this.tempWaitSave) {
                  this.callAPISaveMultipleItems(this.tempWaitSave);
                  this.tempWaitSave = null;
                }
              }
              if (apiPath != this.apiPath) {
                return;
              }
              if (
                this.tempListSaving.length == 1 &&
                this.tempListSaving[0].workBuhinSelected == 0
              ) {
                return;
              }
              this.tempListSaving = [];
            }
          },
          error => {
            console.error("error", error);
            this.$set(this, "isSaving", false);
            let arrNm = this.tempListSaving.map(
              inspect => inspect.sknInspectDescriptionNm
            );
            if (arrNm.length > 0) {
              this.$notify.error({
                title: "エラー",
                message: arrNm.join()
              });
            }
            this.tempListSaving = [];
            setTimeout(() => {
              this.currentData = [];
            }, 0);
            this.initPage();
          }
        );
      }
    }, 800);
  }

  saveSknSaiteiChijouKou(inspectItem: InspectDescriptions) {
    if (inspectItem.sknInspectDescriptionNm.trim() == "地上最低高") {
      let result = inspectItem.inspectResult;
      if (result == 3) {
        result = 2;
      }
      if (result != this.carSelection.sknSaiteiChijouKou) {
        this.carSelection.sknSaiteiChijouKou = result;
        this.reqService.saveCarSelection(this.carSelection);
      }
    }
  }

  clearTimerSave() {
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
  }

  findInspectIndex(list: InspectGenshaSubItem, id: number) {
    return list.inspectDescriptions.findIndex(
      inspect => inspect.sknInspectDescriptionId == id
    );
  }

  onError(res: any) {
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
    this.loading = false;
  }

  onSave() {
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
  }

  onRegister() {
    this.$emit("saveSpentTime");
    let status = "0";
    if (this.inspectType == INSPECT_TYPE.JIZEN) {
      this.data[this.apiPath].forEach((cate: any) => {
        if (cate.osusume) {
          cate.recommend.forEach((subCate: any) => {
            subCate.status = InspectButtonStatus.COMPLETED;
            subCate.subItems.forEach((item: any) => {
              if (item.osusumeIsShow == 1 && item.buhinSelected != 2) {
                subCate.status = InspectButtonStatus.INCOMPLETE;
              }
            });
          });
        }
      });
      status = this.service.getJizenRegisterStatus(this.data[this.apiPath]);
      this.reqService.updateTSknUketsukeExtends(this.uketsukeExtendsId).then(
        (res: any) => {
        },
        (err: any) => {
        }
      );
    } else {
      status = this.service.getRegisterStatus(this.data[this.apiPath]);
    }
    this.$emit("onregister", { pageName: this.$route.name, status });
  }

  onInspectBtnChange(value: number, item: InspectDescriptions) {
    this.service.setInspectResult(value, item);
    this.changeStatus(item);
  }

  changeStatus(item: InspectDescriptions, checkCate?: boolean, isInit?: boolean) {
    this.service.changeStatus(item, isInit);
    if (checkCate !== false) {
      this.changeCateStatus();
    }
  }

  changeCateStatus() {
    let nItem = 0;
    let sumStatus = 0;
    if (this.currentData && this.currentData.length > 0) {
      nItem = this.currentData.reduce(
        (sum, cur: InspectGenshaSubItem) =>
          sum + cur.inspectDescriptions.length,
        0
      );
      this.currentData.forEach((item: InspectGenshaSubItem) => {
        if (item.inspectDescriptions && item.inspectDescriptions.length > 0) {
          sumStatus += item.inspectDescriptions.reduce(
            (sum, cur: InspectDescriptions) =>
              sum + (cur.status ? cur.status : 0),
            0
          );
        }
      });
      // console.log("sumStatus", sumStatus, nItem)
      this.setCateStatus(sumStatus, nItem);
    }
  }

  setCateStatus(
    sumStatus: number,
    nItem: number,
    cate?: InspectGenshaCategory
  ) {
    if (cate == null && this.data[this.apiPath]) {
      cate = this.data[this.apiPath][this.activeCategory];
    }
    if (cate) {
      if (sumStatus == 0) {
        cate.status = InspectButtonStatus.NONE;
      } else if (sumStatus == nItem * InspectButtonStatus.COMPLETED) {
        cate.status = InspectButtonStatus.COMPLETED;
      } else {
        cate.status = InspectButtonStatus.INCOMPLETE;
      }
    }
  }

  isDisabled(item: InspectDescriptions) {
    return this.service.isDisabled(item);
  }

  isComplete(item: any) {
    return this.service.isComplete(item);
  }

  isIncomplete(item: any) {
    return this.service.isIncomplete(item);
  }

  goTop() {
    let wrap = document.querySelector(".select-item-wrap");
    if (wrap) {
      wrap.scrollTop = 0;
    }
  }

  goBackCate() {
    this.clickCount = 0;
    // this.activeCategory--;
    this.changeCategory(this.activeCategory - 1);
  }

  get showBtnBack() {
    if (this.activeCategory > 0) {
      return true;
    }
    return false;
  }

  get backCate() {
    if (this.showBtnBack) {
      return this.data[this.apiPath][this.activeCategory - 1]
        .sknInspectCategoryNm;
    }
    return "";
  }

  goNextCate() {
    this.clickCount = 0;
    if (this.activeCategory < this.data[this.apiPath].length - 1) {
      // this.activeCategory++;
      this.changeCategory(this.activeCategory + 1);
    }
  }

  get showBtnNext() {
    if (
      this.data[this.apiPath] &&
      this.activeCategory < this.data[this.apiPath].length - 1
    ) {
      return true;
    }
    return false;
  }

  get nextCate() {
    if (this.showBtnNext) {
      return this.data[this.apiPath][this.activeCategory + 1]
        .sknInspectCategoryNm;
    }
    return "";
  }

  onClickCategory(e: any, index: number, cate: InspectGenshaCategory) {
    this.clickCount++;
    if (this.clickCount === 1) {
      this.timerClick = setTimeout(() => {
        this.changeCategory(index);
        this.clickCount = 0;
      }, 300);
    } else {
      clearTimeout(this.timerClick);
      this.clickCount = 0;
      if (index != this.activeCategory) {
        this.changeCategory(index);
      } else {
        this.dblclickCategory(index, cate);
      }
    }
  }

  changeCategory(i: number) {
    if (this.activeCategory != i) {
      this.activeCategory = i;
      this.activeSubCategory = 0;
      this.currentData = [];
      setTimeout(() => {
        this.setCurrentData();
      }, 0);
      /** 2021-11-19 sh #7530 improve speed. (for back) [START] */
      /** ここで、カテゴリ情報を覚えておく。backして戻ったときに、最後のカテゴリを開くため */
      const sknInspectCategoryId = this.posToSknInspectCategoryId(i)
      const posSub = this.getLastSelectedSubPos();
      let routeInfo: RouteInfo = {
        apiPath: this.apiPath,
        sknInspectCategoryId: sknInspectCategoryId,
        pos: i,
        subPos: this.inspectType == INSPECT_TYPE.JIZEN ? posSub : 0
      };
      this.setRouteInfo({ data: routeInfo, index: this.inspectType })
      /** 2021-11-19 sh #7530 improve speed. (for back) [END] */
      this.scrollToFirstIncomplete();
    }
  }

  dblclickCategory(index: number, cate: InspectGenshaCategory) {
    if (this.$refs.buttonGroup.every((e: any) => e.value)) {
      return;
    }
    const status = cate.status;
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
    /**
//    this.service.setPassAllCategory(
//      index,
//      this.activeCategory,
//      this.$refs.buttonGroup,
//      cate
//      // (isChange: boolean, subCateIndex: number, index: number) => {
//      // if (isChange) {
//      //   this.saveInspectItem(
//      //     this.currentData[subCateIndex].inspectDescriptions[index]
//      //   );
//      // }
//      // }
//    );
//    */
    /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */

    if (status != InspectButtonStatus.COMPLETED) {
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [START] */
      // this.saveCurrentData();
      let copyCurrentData = util.deepCopy(this.currentData);
      let arrPromises: any[] = Array();
      for (let index=0; index < copyCurrentData.length; index++) {
        let promise = this.setActiveForPassAllCategory(index);
        if (promise) {
          arrPromises.push(promise);
        }
      }

      Promise.all(arrPromises).then((ret)=>{
        if (ret) {
          console.log(ret);
          this.saveCurrentData(ret);
        }
      }, err => {});
      /** 2023-04-27 sh #8188(BQR1084) it does not work after press button(all selecting). [END] */
    }
  }

  showWork(event: any, item: any, subCateIndex: number, itemIndex: number) {
    item.showWork = true;
    this.activeInspect = item;
    this.activeSubCateIndex = subCateIndex;
    this.keepInspectRef(item, subCateIndex, itemIndex);
    /** 2021-09-24 sh #7428 improved initial selecting seibi. [START] */
    setTimeout(() => {
      this.$refs.workBuhinDialog.initialSelectSeibi();
    }, 100);
    /** 2021-09-24 sh #7428 improved initial selecting seibi. [END] */
  }

  onConfirmChangeInspect() {
    this.$refs.buttonGroup[this.buttonIndex].setActive({
      isActive: true,
      value: InspectButtonValue.CIRCLE,
      isAll: false
    });
    const inspection = util.deepCopy(this.tempInspect);
    const ids = inspection.seibiList.map((e: any) => e.seibiDetailId);
    this.removeSeibiId({ ids, type: this.tempInspect.sknInspectType });
    this.service.setInspectResult(InspectButtonValue.CIRCLE, this.tempInspect);
    this.changeStatus(this.tempInspect);
    this.saveInspectItem(this.tempInspect);
    this.$refs.confirmDialog.onClose();

    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [START] */
    if (this.inspectType == INSPECT_TYPE.JIZEN) {
      // console.log("inspectionSelections.onInspectBtnClick this.data.jizen => ", this.tempInspect);
      if (this.tempInspect.inspectResult == InspectButtonValue.CIRCLE) {
        this.service.autoResetSameRecommendSeibi4Jizen(this.data.jizen, this.tempInspect);
      }
    }
    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [END] */
  }
  onCancelChangeInspect() {
    if (this.tempSaveRef[this.tempInspect.sknInspectDescriptionId]) {
      delete this.tempSaveRef[this.tempInspect.sknInspectDescriptionId];
    }
    this.$refs.confirmDialog.onClose();
  }

  askConfirmChange(item: InspectDescriptions, i: number, j: number) {
    this.$refs.confirmDialog.onOpen();
    this.tempInspect = item;
    this.buttonIndex = this.getIndex(i, j);
    this.keepInspectRef(item, i, j);
    this.activeSubCateIndex = i;
  }

  onConfirmBuhin(data: {
    inspectItem: InspectDescriptions;
    seibi: Work;
    notManual: boolean;
  }) {
    this.changeStatus(this.activeInspect);
    let listInspect = this.currentData[
      this.activeSubCateIndex
    ].inspectDescriptions.filter(
      inspect =>
        inspect.sknInspectDescriptionId !=
        data.inspectItem.sknInspectDescriptionId
    );
    if (data.inspectItem.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
      let subCatIndex = 0;
      if (this.activeSubCateIndex == 0) {
        subCatIndex = 1;
      }
      listInspect = listInspect.concat(
        this.currentData[subCatIndex].inspectDescriptions
      );
    }
    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [START] */
    // console.log("inspectionSelections.onConfirmBuhin data => ", this.data.jizen);
    if (data.notManual && this.inspectType == INSPECT_TYPE.JIZEN) {
      this.service.autoSetSameRecommendSeibi4Jizen(this.data.jizen, data.inspectItem, data.seibi, 1);
    }
    /** 2021-09-22 sh #7411 check seibi of recommend for jizen [END] */
    if (data.notManual) {
      this.service.autoSetDuplicateSeibi(listInspect, data.seibi);
    }
  }

  onCallbackDeleteManualSeibi(sknUketsukeInspectId: any) {
    if (sknUketsukeInspectId) {
      this.changeStatus(this.activeInspect);
      this.reqService.sendSocket(this.uketsukeExtendsId, sknUketsukeInspectId);
    }
  }

  onCloseBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    if (event.isResetSeibi || event.isChange) {
      if (event.isSocket) {
        this.isSocket = true;
      } else {
        this.isSocket = false;
      }
      this.changeStatus(this.activeInspect);
      this.saveInspectItem(this.activeInspect);
    }
    this.$set(this, "activeInspect", {});
  }

  closeDialogWork() {
    if (Object.keys(this.activeInspect).length > 0) {
      this.activeInspect.showWork = false;
    }
  }

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  // buttonLabel(inspect: InspectDescriptions) {
  buttonLabel(inspect: any) {
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
    if (inspect.seibiList && inspect.seibiList.length == 0 && inspect.manualSeibiList && inspect.manualSeibiList.length == 0) {
      return "選択なし";
    }
    if (inspect.workBuhinSelected == 0) {
      return "選択";
    }
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    if (!inspect.workBuhinSelected && inspect.sknInspectType == 2 && inspect.buhinSelected == 0) {
      return "選択";
    }
    if (!inspect.workBuhinSelected && inspect.sknInspectType == 4 && inspect.buhinSelected == 0) {
      return "選択";
    }
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
    return "選択済";
  }

  openValueDialog(item: InspectDescriptions, i: number, j: number) {
    this.activeSubCateIndex = i;
    this.service
      .findInspectionByValueViewType(
        this.currentData,
        item.inspectValueViewType
      )
      .then(
        (data: any) => {
          if (data && data.list) {
            this.tempBtnIndexList = [];
            data.index.forEach((item: any) => {
              item.listIndex.forEach((j: number) => {
                this.tempBtnIndexList.push(this.getIndex(item.i, j));
              });
            });
            this.$set(this, "inspectList", data.list);
            this.$set(item, "showValue", true);
          }
        },
        (err: any) => {
          this.$set(this, "inspectList", []);
          this.$set(this, "tempBtnIndexList", []);
          this.$set(item, "showValue", true);
          this.tempBtnIndex = this.getIndex(i, j);
          this.keepInspectRef(item, i, j);
        }
      );
  }

  onConfirmValue(
    inspectValueList: InspectValueItem[],
    item: InspectDescriptions,
    isUserInput: boolean = true,
    saveSideSlip: boolean = true
  ) {
    item.inspectValueList = inspectValueList;
    const isTire = item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE;
    const oldStatus = item.status;
    this.service.setButtonAfterInputValue(
      item,
      this.tempBtnIndex,
      this.$refs.buttonGroup,
      this.carSelection
    );
    this.tempBtnIndex = -1;
    this.changeStatus(item);
    if (
      isUserInput &&
      item.inspectValueViewType != INSPECT_VALUE_VIEW_TYPE.BOOTS
    ) {
      this.service.autoSetInspectValueSameCommentId(
        this.data[this.apiPath],
        item,
        this.callbackAutoInspectValue
      );
    }
    if (isUserInput) {
      this.isSocket = true;
      if (isTire) {
        if (inspectValueList.length == 4) {
          this.carSelection.fLeftTireNokorimizo =
            inspectValueList[0].inspectValue;
          this.carSelection.fRightTireNokorimizo =
            inspectValueList[1].inspectValue;
          this.carSelection.rLeftTireNokorimizo =
            inspectValueList[2].inspectValue;
          this.carSelection.rRightTireNokorimizo =
            inspectValueList[3].inspectValue;
        }
        this.reqService.saveCarSelection(this.carSelection);
      }
      if (
        saveSideSlip &&
        this.useLine &&
        item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP &&
        this.inspectLineList.length > 0
      ) {
        this.inspectLineList[0].inspectValue = inspectValueList[0].inspectValue;
        this.reqService.saveInspectLineResult(this.inspectLineList[0]);
        this.setSideSlip(this.inspectLineList[0].inspectValue);
      }
    }
    this.saveInspectItem(item);
  }

  callbackAutoInspectValue(inspect: InspectDescriptions, i: number, j: number) {
    let btnIndex = this.getIndex(i, j);
    this.service.setButtonAfterInputValue(
      inspect,
      btnIndex,
      this.$refs.buttonGroup,
      this.carSelection
    );
    this.saveInspectItem(inspect);
  }
  hasValue(inspect: InspectDescriptions) {
    if (
      inspect.inspectValueList != null &&
      inspect.inspectValueList.length > 0 &&
      inspect.inspectValueList.every(
        (val: InspectValueItem) =>
          !(val.inspectValue == null || val.inspectValueStr == null || val.inspectValue == '' || val.inspectValueStr == '')
      )
    ) {
      return "green";
    } else if (this.isIncomplete(inspect)) {
      return "red";
    }
    return "normal";
  }
  hasValueWork(inspect: InspectDescriptions) {
    if (inspect.workBuhinSelected != null && inspect.workBuhinSelected > 0) {
      return "green";
    } else if (this.isIncomplete(inspect)) {
      return "red";
    }
    return "normal bold";
  }

  updateInspectList(data: any, sendOneSocket: boolean = false) {
    let sendSocket = true;
    const inspectList = data[this.apiPath][0].subItems[0].inspectDescriptions;
    if (inspectList.length > 0) {
      inspectList.forEach((itemRes: any) => {
        if (this.tempSaveRef[itemRes.sknInspectDescriptionId]) {
          const { cateIndex, subCateIndex, itemIndex } = this.tempSaveRef[
            itemRes.sknInspectDescriptionId
          ];
          delete this.tempSaveRef[itemRes.sknInspectDescriptionId];
          const inspectRef = this.data[this.apiPath][cateIndex].subItems[
            subCateIndex
          ].inspectDescriptions[itemIndex];
          const showValue = inspectRef.showValue;
          const showWork = inspectRef.showWork;
          let seibiList = inspectRef.seibiList;
          if (itemRes.seibiList.length > 0) {
            seibiList.forEach((seibi: any, index: number) => {
              const seibiRes = itemRes.seibiList.find(
                (e: any) =>
                  e.seibiDetailId == seibi.seibiDetailId &&
                  e.workCd == seibi.workCd
              );
              if (seibiRes) {
                if (itemRes.inspectResult == InspectButtonValue.CIRCLE) {
                  seibiRes.seibiId = null;
                  seibiRes.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
                  seibiRes.manualBuhinList = [];
                  seibiRes.buhinList = seibi.buhinList.map((buhin: any) => {
                    let buhinMap = { ...buhin };
                    buhinMap.id = null;
                    buhinMap.isDelete = 0;
                    return buhinMap;
                  });
                }
                seibiList[index] = seibiRes;
              }
            });
          }
          if (itemRes.inspectResult == InspectButtonValue.CIRCLE) {
            itemRes.manualSeibiList = [];
          }
          itemRes.seibiList = seibiList;
          this.changeStatus(itemRes);
          if (sendSocket) {
            if (
              sendSocket &&
              (this.isSocket ||
                (!sendOneSocket &&
                  itemRes.status == InspectButtonStatus.COMPLETED)) &&
              itemRes.sknUketsukeInspectId
            ) {
              this.reqService.sendSocket(
                this.uketsukeExtendsId,
                itemRes.sknUketsukeInspectId
              );
            }
            if (sendOneSocket) {
              this.isSocket = false;
            }
          }
          this.$set(
            this.data[this.apiPath][cateIndex].subItems[subCateIndex]
              .inspectDescriptions,
            itemIndex,
            { ...itemRes, showWork, showValue, isSaving: false }
          );
          // console.log(this.currentData[subCateIndex].inspectDescriptions[itemIndex]);
        } else if (this.isSocket) {
          if (sendOneSocket || this.inspectType == INSPECT_TYPE.JIZEN) {
            this.isSocket = false;
            this.inspectList.forEach(
              (inspect: InspectDescriptions, i: number) => {
                inspect.isSaving = false;
              }
            );
          }
          this.reqService.sendSocket(
            this.uketsukeExtendsId,
            itemRes.sknUketsukeInspectId
          );
        }
      });
    }
  }

  onInspectBtnClick(item: any, subCateIndex: number, itemIndex: number) {
    item.isSaving = true;
    this.keepInspectRef(item, subCateIndex, itemIndex);
    this.saveInspectItem(item);
  }

  keepInspectRef(item: any, subCateIndex: number, itemIndex: number) {
    this.tempSaveRef[item.sknInspectDescriptionId] = {
      cateIndex: this.activeCategory,
      subCateIndex,
      itemIndex,
      seibiList: []
    };
  }

  setSaving(sknInspectDescriptionId: number) {
    const item = this.tempSaveRef[sknInspectDescriptionId];
    if (item) {
      const { subCateIndex, itemIndex } = item;
      if (subCateIndex > -1 && itemIndex > -1) {
        this.currentData[subCateIndex].inspectDescriptions[
          itemIndex
        ].isSaving = true;
      }
    }
  }

  onConfirmInspectListValue(inspectList: InspectDescriptions[]) {
    if (this.inspectList.length > 0 && this.tempBtnIndexList.length > 0) {
      this.isSocket = true;
      this.inspectList.forEach((inspect: InspectDescriptions, i: number) => {
        inspect.isSaving = true;
        inspect.inspectValueList = inspectList[i].inspectValueList;
        this.service.setButtonAfterInputValue(
          inspect,
          this.tempBtnIndexList[i],
          this.$refs.buttonGroup
        );
        this.saveInspectItem(inspect);
      });
    }
  }

  scrollToFirstIncomplete() {
    let isGoTop = true;
    const data = this.currentData;
    if (
      data.length > 0 &&
      this.data[this.apiPath][this.activeCategory].status ===
        InspectButtonStatus.INCOMPLETE
    ) {
      let pIndex = -1,
        index = -1;
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].inspectDescriptions.length; j++) {
          if (
            data[i].inspectDescriptions[j].status ==
            InspectButtonStatus.NONE
          ) {
            index = j;
            pIndex = i;
            break;
          } else if (
            data[i].inspectDescriptions[j].status ==
            InspectButtonStatus.INCOMPLETE) {
            index = j;
            pIndex = i;
            break;
          }
        }
        if (index > -1) {
          break;
        }
      }
      if (index > -1) {
        isGoTop = false;
        const iDiv = this.getIndex(pIndex, index);
        const div = document.getElementById("div-row-" + iDiv);
        let wrap = document.querySelector(".select-item-wrap");
        setTimeout(() => {
          if (div && wrap) {
            const pos = div.getBoundingClientRect().top - 200;
            wrap.scrollTo(0, pos);
          }
        });
      }
    }
    if (isGoTop) {
      this.goTop();
    }
  }

  isNoSeibi(inspect: InspectDescriptions) {
    const list = [
      "前方ｴｱﾊﾞｯｸﾞ警告灯",
      "側方ｴｱﾊﾞｯｸﾞ警告灯",
      "ﾌﾞﾚｰｷ警告灯",
      "ABS警告灯",
      "ｴﾝｼﾞﾝ警告灯",
      "自動ﾌﾞﾚｰｷ",
      "ﾚｰﾝｷｰﾌﾟ",
      "自動運行装置"
    ];
    if (list.indexOf(inspect.sknInspectDescriptionNm.trim()) > -1) {
      return true;
    } else {
    return this.service.isNoSeibi(inspect);
    }
  }

  beforeDestroy() {
    this.closeDialogWork();
    if (this.timerSave || this.tempListSave.length > 0) {
      if (this.tempListSave.length > 0) {
        this.reqService.saveInspect(
          this.getObjForSave(this.apiPath),
          this.apiPath
        );
      }
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    if (this.tempWaitSave && this.timerSaving) {
      this.saveInspectItem(this.tempWaitSave);
      clearTimeout(this.timerSaving);
    }
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }

  isStatusNone(item: any) {
    return this.service.isStatusNone(item);
  }

  isShow(inspect: any) {
    if (inspect.osusumeIsShow) {
      return "green";
    }
    return "normal bold";
  }

  isDuplicate(item: any) {
    return item.isInspectDuplicate == 1;
  }

  onClickSubCategory(e: any, index: number, subIndex: number, cate: InspectGenshaCategory) {
    this.clickCount++;
    if (index == this.activeCategory) {
    if (this.clickCount === 1) {
      this.timerClick = setTimeout(() => {
        this.changeSubCategory(subIndex);
        this.clickCount = 0;
      }, 300);
    } else {
      clearTimeout(this.timerClick);
      this.clickCount = 0;
      if (subIndex != this.activeSubCategory) {
        this.changeSubCategory(subIndex);
      } else {
        this.dblclickCategory(subIndex, cate);
      }
    }
    }
  }

  changeSubCategory(i: number) {
    if (this.activeSubCategory != i) {
      this.activeSubCategory = i;
      this.currentData = [];
      setTimeout(() => {
        this.setCurrentData();
      }, 0);
      /** 2021-11-22 sh #7530 improve speed. (for back) [START] */
      /** ここで、カテゴリ情報を覚えておく。backして戻ったときに、最後のカテゴリを開くため */
      const sknInspectCategoryId = this.posToSknInspectCategoryId(i)
      let routeInfo: RouteInfo = {
        apiPath: this.apiPath,
        sknInspectCategoryId: sknInspectCategoryId,
        pos: this.activeCategory,
        subPos: this.activeSubCategory
      };
      this.setRouteInfo({ data: routeInfo, index: this.inspectType })
      /** 2021-11-22 sh #7530 improve speed. (for back) [END] */
      this.scrollToFirstIncomplete();
    }
  }

  isSubActive(i: number, k: number) {
    return (this.activeCategory == i && this.activeSubCategory == k);
  }

  onChangeShow(item: any, index: number) {
    if (item.isInspectDuplicate && item.osusumeIsShow) {
      this.errorMsg = "現車確認又は57項目点検で関連する点検項目が「×」になっている為解除できません。";
      this.$refs.errorDialog.onOpen();
    } else if (item.buhinSelected == 0 || item.osusumeIsShow == 0) {
      item.osusumeIsShow = item.osusumeIsShow ? 0 : 1;
      if (item.osusumeIsShow == 0) {
        item.inspectResult = 0;
      }
      this.activeInspect = item;
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeOsusumeStatus(item);
      item.osusumeBuhinList = null;
      item.buhinList = [];
      this.saveSeibiItem(item);
    } else {
      this.askConfirmOsusumeChange(item, index);
    }
  }

  saveSeibiItem(inspectItem: InspectRecommendSubItem) {
    inspectItem.isSaving = true;
    if (this.data.recommend) {
      this.service.autoSetSameRecommendSeibi(this.data.jizen[this.activeCategory].recommend, inspectItem);
    }
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    let objForSave: InspectRecommendSubItem = JSON.parse(
      JSON.stringify(inspectItem)
    );
    this.arrStatus.push(objForSave.status || 0);
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.isSaving;
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
      }
    }
    if (this.data.jizen[this.activeCategory].recommend) {
      objForSave.sknRecommendInspectCategoryId = this.data.jizen[this.activeCategory].recommend[
        this.activeSubCategory
      ].sknRecommendInspectCategoryId;
    }
      if (this.isSaving) {
      let index = -1;
      if (this.tempWaitSave.length > 0) {
        index = this.findSeibiIndex(this.tempWaitSave, objForSave);
      }
      if (index > -1) {
        this.tempWaitSave[index] = objForSave;
      } else {
        this.tempWaitSave.push(objForSave);
      }
    } else {
      const data = this.getObjForSaveOsusume(inspectItem);
      this.saveAndUpdateData(data);
    }
  }

  findSeibiIndex(list: any, seibiSave: any) {
    return list.findIndex(
      (seibi: any) =>
        (seibi.sknRecommendInspecSeibiId &&
          seibi.sknRecommendInspecSeibiId ==
            seibiSave.sknRecommendInspecSeibiId) ||
        (seibi.osusumeId && seibi.osusumeId == seibiSave.osusumeId)
    );
  }

  getObjForSaveOsusume(item: any = null) {
    let subItems: any = [];
    let manualItems: any = [];
    let items: any = [];
    if (!item) {
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
      // items = this.tempListSave;
      items = util.deepCopy(this.tempListSave);
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
    } else {
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
      // items.push(item);
      items = items.concat(item);
      /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
    }
    items.forEach((element: any) => {
        let buhinList: any = [];
        if (element.buhinList && element.buhinList.length > 0) {
          element.buhinList.forEach((element: any) => {
            buhinList.push({
              buhinCd: element.buhinCd
            , buhinId: element.buhinId
            , buhinNm: element.buhinNm
            , buhinPriceZk: element.buhinPriceZk
            , buhinPriceZn: element.buhinPriceZn
            , buhinShubetsuId:element.buhinShubetsuId
            , isDelete: element.isDelete
            , isExtreme: element.isExtreme
            , kingakuZk: element.kingakuZk
            , kingakuZn: element.kingakuZn
            , quantity: element.quantity
            , quantityStep: element.quantityStep
            , id: element.id ? element.id: null
            /** #8299(BQR1105) It does not work discount when buhin count is 1. [START] */
            , buhinMasterZk: element.buhinMasterZk ? element.buhinMasterZk : null
            , buhinMasterZn: element.buhinMasterZn ? element.buhinMasterZn : null
            /** #8299(BQR1105) It does not work discount when buhin count is 1. [END] */
            });
          });
        }
        let osusumeBuhinList: any = [];
        if (element.osusumeBuhinList && element.osusumeBuhinList.length > 0) {
          element.osusumeBuhinList.forEach((element: any) => {
            osusumeBuhinList.push({
                buhinCd: element.buhinCd
              , buhinId: element.buhinId
              , buhinLinkId: element.buhinLinkId
              , buhinNm: element.buhinNm
              , buhinOsusumeId: element.buhinOsusumeId
              , buhinPriceZk: element.buhinPriceZk
              , buhinPriceZn: element.buhinPriceZn
              , buhinShubetsuId: element.buhinShubetsuId
              , id: element.id
              , isDelete: element.isDelete
              , isExtreme: element.isExtreme
              , kingakuExtensionId: element.kingakuExtensionId
              , kingakuZk: element.kingakuZk
              , kingakuZn: element.kingakuZn
              , koukanMeyasuTime: element.koukanMeyasuTime
              , kousuu: element.kousuu
              , quantity: element.quantity
              , quantityStep: element.quantityStep
            /** #8299(BQR1105) It does not work discount when buhin count is 1. [START] */
            , buhinMasterZk: element.buhinMasterZk ? element.buhinMasterZk : null
            , buhinMasterZn: element.buhinMasterZn ? element.buhinMasterZn : null
            /** #8299(BQR1105) It does not work discount when buhin count is 1. [END] */
            });
          });
        }
      /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [START] */
      // if (element.osusumeId != null || element.sknRecommendInspecSeibiId != null) {
      if ((element.osusumeId != null || element.sknRecommendInspecSeibiId != null) && element.manualSeibiId == null) {
      /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [END] */
        let subItem = {
            branchId: element.branchId
          , buhinBunruiList: element.buhinBunruiList ? element.buhinBunruiList: []
          , buhinList: buhinList
          , buhinSelected: element.buhinSelected
          , inspectResult: element.inspectResult
          , inspectValue: element.inspectValue
          , isDoTenken: element.isDoTenken
          , isInspectDuplicate: element.isInspectDuplicate
          , isNumber: element.isNumber
          , kouchinZn: element.kouchinZn
          , koukanMeyasuTime: element.koukanMeyasuTime
          , manualBuhinList: element.manualBuhinList ? element.manualBuhinList: []
          , osusumeBuhinList: osusumeBuhinList
          , osusumeId: element.osusumeId ? element.osusumeId: null
          , osusumeIsShow: element.osusumeIsShow
          , seibiId: element.seibiId
          , sknInspectSeibiDetailId: element.sknInspectSeibiDetailId
          , sknInspectType: element.sknInspectType
          , sknRecommendInspecSeibiId: element.sknRecommendInspecSeibiId
          , sknRecommendInspecSeibiNm: element.sknRecommendInspecSeibiNm
          , sknRecommendInspectCategoryId: element.sknRecommendInspectCategoryId
          , sknRecommendInspectSubCategoryId: element.sknRecommendInspectSubCategoryId
          , sknUketsukeExtendsId: element.sknUketsukeExtendsId
          , inspectQuantity: element.inspectQuantity ? element.inspectQuantity: null
          , kousuu: element.kousuu ? element.kousuu: null
          , buhinShubetsuCd: element.buhinShubetsuCd ? element.buhinShubetsuCd: null
          , kouchinZk: element.kouchinZk ? element.kouchinZk: null
          // 2022-01-25 morisako extreme作業引用＆明細取込の改善 BQR-051 [START]
          , isExtreme:  element.isExtreme
          // 2022-01-25 morisako extreme作業引用＆明細取込の改善 BQR-051 [END]
          /** 2022-01-22 sh #7656(BQR039) add isExtreme for BQR786. [START] */
          , workCd: element.workCd
          /** 2022-01-22 sh #7656(BQR039) add isExtreme for BQR786. [END] */
        }
        /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [START] */
        // subItems.push(subItem);
        if (element.seibiId == null && element.osusumeIsShow == 0) {
          // 未登録なデータを「しない」にしているので、何もしない
        } else {
          subItems.push(subItem);
        }
        /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [END] */
      } else {
        let manualItem = {
          sknUketsukeExtendsId: this.uketsukeExtendsId + ''
          , seibiId: element.seibiId
          , seibiNm: element.sknRecommendInspecSeibiNm
          , kouchinZn: element.kouchinZn
          , buhinSelected: element.osusumeIsShow == 1 ? STATUS_SELECT_WORK_BUHIN.Done : STATUS_SELECT_WORK_BUHIN.delete // modify
          , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
          , sknRecommendInspectCategoryId: this.data.jizen[this.activeCategory].recommend ? this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].sknRecommendInspectCategoryId: element.sknRecommendInspectCategoryId
          , osusumeIsShow: element.osusumeIsShow // modify
          , buhinList: buhinList
          , manualBuhinList: element.manualBuhinList
          , osusumeBuhinList: osusumeBuhinList
          , kouchinZk: element.kouchinZk ? element.kouchinZk: null
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
          , buhinEditTotalZk: element.buhinEditTotalZk
          , buhinEditTotalZn: element.buhinEditTotalZn
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
        }
        manualItems.push(manualItem);
      }
    });
    const isSocket = this.getIsSocket();
    const data = {
      isSocket,
      jizen: [
        {
          recommend: [
            {
              subItems: subItems
              , manualItems: manualItems
            }
          ]
        }
      ]
    };
    return data;
  }

  saveAndUpdateData(data: any, isUpdateAll: boolean = false) {
    this.isSaving = true;
    this.reqService.saveJizenRecommend(data).then(
      (res: any) => {
        if (res.status == 200 && res.body) {
          this.isSocket = true;
          this.isSaving = false;
          //通常検査と手入力検査で異なる
          if (data.jizen[0].recommend[0].subItems) {
            data.jizen[0].recommend[0].subItems
              // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
//              .map((item: any) => item.osusumeId ? item.osusumeId : item.sknRecommendInspecSeibiId)
              .map((item: any) => item.osusumeId ? item.osusumeId: item.sknRecommendInspecSeibiId ? item.sknRecommendInspecSeibiId: item.manualSeibiId)
              // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
              .forEach((key: number) => {
                const target = this.currentData.findIndex(
                  (i: any) =>
                    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
                    // (i.osusumeId && i.osusumeId === key) || (i.sknRecommendInspecSeibiId && i.sknRecommendInspecSeibiId === key)
                    (i.osusumeId && i.osusumeId === key) || (i.sknRecommendInspecSeibiId && i.sknRecommendInspecSeibiId === key) || (i.manualSeibiId && i.manualSeibiId === key)
                    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
                );
                if (target > -1) {
                  this.currentData[target].isSaving = false;
                }
              });
            // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
          }
          /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [START] */
          if (data.jizen[0].recommend[0].manualItems) {
            /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [END] */
            data.jizen[0].recommend[0].manualItems
              .map((item: any) => item.seibiId)
              .forEach((key: number) => {
                const target = this.currentData.findIndex(
                  (i: any) =>
                    (i.seibiId && i.seibiId === key)
                );
                if (target > -1) {
                  this.currentData[target].isSaving = false;
                }
              });
            /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [START] */
          }
          /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [END] */
          // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
          if (this.tempWaitSave && this.tempWaitSave.length > 0) {
            /** 2021-08-25 sh #7365 Pressing button continuously may fail. [START] */
            // const data = this.getObjForSave(util.deepCopy(this.tempWaitSave));
            const data = this.getObjForSaveOsusume(util.deepCopy(this.tempWaitSave));
            /** 2021-08-25 sh #7365 Pressing button continuously may fail. [END] */
            this.saveAndUpdateData(data);
            this.tempWaitSave = [];
          }
          this.tempListSave = [];
          this.arrStatus = [];
          this.initData(res.body);
        }
      },
      error => {
        console.error("error", error.rsltComment);
        // let arrNm = this.tempListSave.map(
        //   inspect => inspect.sknRecommendInspecSeibiNm
        // );
        // if (arrNm.length > 0) {
        //   this.$notify.error({
        //     title: "エラー",
        //     message: arrNm.join()
        //   });
        // }
      }
    );
  }

  initData(res: any) {
    if (res.jizen[0].recommend) {
      const promise = res.jizen[0].recommend.map((cate: any) => {
        let sumStatus = 0;
        //通常検査と手入力検査で異なる
        if (cate.subItems) {
          cate.subItems = cate.subItems.map((obj: any) => {
            this.changeOsusumeStatus(obj, false);
            if (obj.status) {
              sumStatus += obj.status;
            }
            if (obj.rowNum > this.maxRowNum) this.maxRowNum = obj.rowNum;
            return {
              ...obj,
              showWork: false
            };
          });
          this.setOsusumeCateStatus(sumStatus, cate.subItems.length, cate);
        }
        if (cate.manualItems) {
          cate.manualItems = cate.manualItems.map((obj: any) => {
            this.changeOsusumeStatus(obj, false);
            if (obj.status) {
              sumStatus += obj.status;
            }
            if (obj.rowNum > this.maxRowNum) this.maxRowNum = obj.rowNum;
            return {
              ...obj,
              showWork: false
            };
          });
          this.setOsusumeCateStatus(sumStatus, cate.manualItems.length, cate);
        }
        return cate;
      });
      Promise.all(promise).then((val: any) => {
        if (val[0].subItems && val[0].subItems.length > 0) {
          val[0].subItems.forEach((element: any) => {
            this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems.map((e: any) => {
              // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [START]
              // if ((element.osusumeId && element.osusumeId == e.osusumeId) || (element.sknRecommendInspecSeibiId && element.sknRecommendInspecSeibiId == e.sknRecommendInspecSeibiId)) {
              if ((element.osusumeId && element.osusumeId == e.osusumeId) || (element.sknRecommendInspecSeibiId && element.sknRecommendInspecSeibiId == e.sknRecommendInspecSeibiId)
                || (element.seibiId && element.seibiId == e.seibiId)) {
              // 2022-07-00 BQR1109 手入力作業の工賃変更対応 mod [END]
                return { ...element };
              }
              return { ...e };
            });
          });
        }
        /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [START] */
        if (val[0].manualItems && val[0].manualItems.length > 0) {
          val[0].manualItems.forEach((element: any) => {
            if (this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems
              && this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems.length > 0
            ) {
              this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems
                = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems
              .filter((e: any) => {
                if (element.seibiId && element.seibiId == e.seibiId) {
                  if (element.buhinSelected == 4) return;
                }
                return e;
              }).map((e: any) => {
                if (element.seibiId && element.seibiId == e.seibiId) {
                  //画面表示内容とレスポンス内容で構造が異なるので必要な値を反映する
                  e.buhinList        = element.buhinList;
                  e.buhinSelected    = element.buhinSelected;
                  e.buhinShubetsuCd  = element.buhinShubetsuCd;
                  e.kouchinZk        = element.kouchinZk;
                  e.kouchinZn        = element.kouchinZn;
                  e.koukanMeyasuTime = element.koukanMeyasuTime;
                  e.kousuu           = element.kousuu;
                  e.manualBuhinList  = element.manualBuhinList;
                  e.osusumeBuhinList = element.osusumeBuhinList;
                  e.osusumeIsShow    = element.osusumeIsShow;
                  return { ...e };
                }
                return { ...e };
              });
            }
          });
        }
        /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [END] */
        this.setInspectRecommend(this.data);
        this.setOsusumeCurrentData();
      });
    }
  }

  changeOsusumeStatus(item: InspectRecommendSubItem, checkCate?: boolean) {
    this.service.changeStatusRecommendSeibi2(item);
    if (checkCate !== false) {
      this.changeOsusumeCateStatus();
    }
  }

  changeOsusumeCateStatus() {
    let nItem = this.currentData.length;
    let sumStatus = 0;
    if (this.currentData && this.currentData.length > 0) {
      sumStatus = this.currentData.reduce(
        (sum, cur: any) =>
          sum + (cur.status ? cur.status : 0),
        0
      );
    }
    this.setOsusumeCateStatus(sumStatus, nItem);
  }

  setOsusumeCateStatus(
    sumStatus: number,
    nItem: number,
    cate?: InspectRecommendCategory
  ) {
    if (cate == null && this.data.jizen[this.activeCategory].recommend) {
      cate = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory];
    }
    if (cate) {
      if (sumStatus == 0) {
        cate.status = InspectButtonStatus.NONE;
      } else if (sumStatus == nItem * InspectButtonStatus.COMPLETED) {
        cate.status = InspectButtonStatus.COMPLETED;
      } else {
        cate.status = InspectButtonStatus.INCOMPLETE;
      }
    }
  }

  onCloseOsusumeBuhin(event: {
    isChange: boolean;
    isResetSeibi: boolean;
    isSocket: boolean;
  }) {
    if (event.isResetSeibi || event.isChange) {
      if (event.isSocket) {
        this.isSocket = true;
      } else {
        this.isSocket = false;
      }
      this.changeOsusumeStatus(this.activeInspect);
      const data = this.getObjForSaveOsusume(this.activeInspect);
      this.saveAndUpdateData(data);
      /** 2021-10-01 sh #7411 put loading after add buhin. [START] */
      this.activeInspect.isSaving = true;
      /** 2021-10-01 sh #7411 put loading after add buhin. [END] */
    }
    this.$set(this, "activeInspect", {});
  }

  showOsusumeWork(event: any, item: any) {
    item.showWork = !item.showWork;
    if (item.showWork) {
      this.activeInspect = item;
    } else {
      this.activeInspect = {};
    }
  }

  setOsusumeCurrentData() {
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    this.kingakuFlg=false;
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
    if (this.isSaving) {
      return;
    }
    if (this.data.jizen[this.activeCategory].recommend) {
      let kingakuZn = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].kingakuZn ? this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].kingakuZn: null;
      let kingakuZk = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].kingakuZk ? this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].kingakuZk: null
      if ((kingakuZn && kingakuZn > 0) || (kingakuZk && kingakuZk > 0)) {
        this.kingakuFlg = true;
      }
      this.loadData = true;
      let currentData = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems.map(
        (item: InspectRecommendSubItem) => {
          return {
            ...item,
            isSaving: false
          };
        }
      );
      this.currentData = []; // 一旦空にする
      Promise.all(currentData).then(vals => {
        vals.map((val: any, i: number) => {
          this.$set(this.currentData, i, util.deepCopy(val));
        });
      });
    }
  }

  isOsusumeDisabled(item: InspectRecommendSubItem) {
    if (item.osusumeIsShow) {
      return false;
    }
    return true;
  }

  hasOsusumeValueWork(inspect: any) {
    if (inspect.buhinSelected != null && inspect.buhinSelected > 0) {
      return "green";
    } else if (this.isIncomplete(inspect)) {
      return "red";
    }
    return "normal bold";
  }

  onConfirmOsusumeBuhin(item: InspectRecommendSubItem) {
    /** 2021-09-15 sh #7404 set to suru, if selecting buhin. [START] */
    /** おすすめの場合、先に部品の子画面を開くことはないので、ここでフラグを立てる */
    item.isDoTenken = (item.osusumeIsShow == 1) ? 1 : 0;
    /** 2021-09-15 sh #7404 set to suru, if selecting buhin. [END] */
    this.changeOsusumeStatus(item);
    this.saveOsusumeBuhin(item);
  }

  saveOsusumeBuhin(inspectItem: InspectRecommendSubItem) {
    inspectItem.isSaving = true;
    if (this.data.recommend) {
      this.service.autoSetSameRecommendSeibi(this.data.recommend, inspectItem);
    }
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }
    let objForSave: InspectRecommendSubItem = JSON.parse(
      JSON.stringify(inspectItem)
    );
    this.arrStatus.push(objForSave.status || 0);
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.isSaving;
    if (objForSave.buhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
      objForSave.buhinList = this.service.removeDefualtBuhin(
        objForSave.buhinList
      );
      if (objForSave.osusumeBuhinList) {
        objForSave.osusumeBuhinList = this.service.removeDefualtBuhin(
          objForSave.osusumeBuhinList
        );
      }
    }
    if (this.data.recommend) {
      objForSave.sknRecommendInspectCategoryId = this.data.recommend[
        this.activeCategory
      ].sknRecommendInspectCategoryId;
    }
    if (this.isSaving) {
      let index = -1;
      if (this.tempWaitSave.length > 0) {
        index = this.findSeibiIndex(this.tempWaitSave, objForSave);
      }
      if (index > -1) {
        this.tempWaitSave[index] = objForSave;
      } else {
        this.tempWaitSave.push(objForSave);
      }
    } else {
      let index = -1;
      /** 2021-09-15 sh #7404 set to suru, if selecting buhin. [START] */
      // index = this.findSeibiIndex(this.tempListSave, objForSave);
      index = this.findSeibiIndex(this.tempOsusumeListSave, objForSave);
      if (this.tempOsusumeListSave == null) {
        this.tempOsusumeListSave = [];
      }
      //index = this.findSeibiIndex(this.tempWaitSave, objForSave);
      if (index > -1) {
        // this.tempListSave[index] = objForSave;
        this.tempOsusumeListSave[index] = objForSave;
      } else {
        // this.tempListSave.push(objForSave);
        this.tempOsusumeListSave.push(objForSave);
      }
      /** 2021-09-15 sh #7404 set to suru, if selecting buhin. [END] */
    }
  }

  askConfirmOsusumeChange(item: InspectRecommendSubItem, index: number) {
    this.$refs.osusumeConfirmDialog.onOpen();
    this.tempOsusumeInspect = item;
    this.tempIndex = index;
  }

  onConfirmChangeOsusumeInspect() {
    this.arrStatus.push(InspectButtonStatus.COMPLETED);
    this.activeInspect = {};
    this.tempOsusumeInspect.osusumeIsShow = 0;
    this.service.setInspectResultRecomend2(0, this.tempOsusumeInspect);
    if (this.tempOsusumeInspect.isInspectDuplicate == 0) {
      this.deleteAlManualBuhin(this.tempOsusumeInspect);
      this.service.deletAllBuhinInSebi([this.tempOsusumeInspect]);
      this.tempOsusumeInspect.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    }
    this.changeOsusumeStatus(this.tempOsusumeInspect);
    this.saveSeibiItem(this.tempOsusumeInspect);
    this.$refs.osusumeConfirmDialog.onClose();
  }

  onCancelChangeOsusumeInspect() {
    this.$refs.osusumeConfirmDialog.onClose();
  }

  deleteAlManualBuhin(item: any) {
    if (item.manualBuhinList.length > 0) {
      const manualBuhinList = util.deepCopy(item.manualBuhinList);
      item.manualBuhinList = [];
      manualBuhinList.forEach((buhin: any) => {
        if (buhin.id) {
          this.reqService.deleteManualBuhin(buhin.id);
        }
      });
    }
  }

  isOBD(subCate: InspectGenshaCategory) {
    if (subCate.sknInspectCategoryNm.trim() == "OBDの診断の結果"
      || subCate.sknInspectCategoryNm.trim() == "ﾒｰﾀｰﾊﾟﾈﾙ警告灯状態") {
      return true;
    }
    return false;
  }
  /** 2021-11-08 sh #7530 improve speed.(No.1) [START] */
  getInspectByCategoryId(sknUketsukeExtendsId: any, apiPath: any, sknInspectCategoryId: any) {
    const promise = this.getInspectByCategoryIdPM(sknUketsukeExtendsId, apiPath, sknInspectCategoryId);

    Promise.all([promise]).then((val: any) => {
      if (val.length>0) {
        this.data[apiPath].forEach((e: any) => {
          if (e.sknInspectCategoryId == sknInspectCategoryId) {
            /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
            this.$set(this.cateLoadingList, sknInspectCategoryId, false);
            /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
            e.subItems = val[0];
            this.addStatus();
          }
        });
      }
    }, (err: any) => {
      // エラー処理
      /** 2021-12-09 sh #7610 stop loading if subItems is none. [START] */
      this.$set(this.cateLoadingList, sknInspectCategoryId, false);
      /** 2021-12-09 sh #7610 stop loading if subItems is none. [END] */
    });
  }
  getInspectByCategoryIdPM(sknUketsukeExtendsId: any, apiPath: any, sknInspectCategoryId: any) {
    /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
    this.$set(this.cateLoadingList, sknInspectCategoryId, true);
    /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
    const promise = new Promise((resolve, reject) => {
      this.reqService.getInspectByCategoryId(sknUketsukeExtendsId, apiPath, sknInspectCategoryId).then((res: any)=>{
        if (this.inspectType == INSPECT_TYPE.GENSHA) {
          const dataCategorySubItemsFiltered = res.gensha.filter((e: any) => {
            if (e.sknInspectCategoryId == sknInspectCategoryId) {
              return e;
            }
          });
          if (dataCategorySubItemsFiltered.length > 0) {
            const subItems = dataCategorySubItemsFiltered[0].subItems;
            resolve(subItems);
          } else {
            reject();
          }
          /** 2021-11-22 sh #7530 improve speed.(for back) [START] */
        } else if (this.inspectType == INSPECT_TYPE.LEGAL56) {
          const dataCategorySubItemsFiltered = res.legal56.filter((e: any) => {
            if (e.sknInspectCategoryId == sknInspectCategoryId) {
              return e;
            }
          });
          if (dataCategorySubItemsFiltered.length > 0) {
            const subItems = dataCategorySubItemsFiltered[0].subItems;
            resolve(subItems);
          } else {
            reject();
          }
        } else if (this.inspectType == INSPECT_TYPE.JIZEN) {
          const dataCategorySubItemsFiltered = res.jizen.filter((e: any) => {
            if (e.sknInspectCategoryId == sknInspectCategoryId) {
              return e;
            }
          });
          if (dataCategorySubItemsFiltered.length > 0) {
            const subItems = dataCategorySubItemsFiltered[0].subItems;
            resolve(subItems);
          } else {
            reject();
          }
          /** 2021-11-22 sh #7530 improve speed.(for back) [END] */
        }
      }, (err: any) => reject(err));
    });

    return promise;
  }
  /** 2021-11-08 sh #7530 improve speed.(No.1) [END] */

  /** 2021-11-18 sh #7530 improve speed.(No.1) [START] */
  isCateLoading(category: any) {
    const key =  category.sknInspectCategoryId;
    if (key in this.cateLoadingList) {
      if (this.cateLoadingList[key] == true) {
        return true;
      }
    }
    return false;
  }

  cateRefName(pos: any) {
    return "cate-" + pos;
  }
  /** 2021-11-18 sh #7530 improve speed.(No.1) [END] */

  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) this.freeOfChargeNm = res.freeOfChargeNm;
    });
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
  onConnect() {
    console.log("inspectionSelections.onConnect >>>>>> ");
    this.sktControll.socketInspectionsBase(this.initPage);
  }
  destroyed() {
    this.sktControll.freeSocketResources();
  }
  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  isShowAll(show: number) {
    return this.currentData.every((seibi: any) => seibi.osusumeIsShow == show);
  }

  showAll() {
    if (this.isShowAll(1)) {
      return;
    }
    this.currentData.forEach((item :any) => {
      item.osusumeIsShow = 1;
      if (item.buhinList && item.buhinList.length == 0 && item.osusumeBuhinList && item.osusumeBuhinList.length == 0) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      } else if (!item.osusumeBuhinList && item.buhinBunruiList && item.buhinBunruiList.length == 0 && item.buhinList && item.buhinList.length == 0) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      } else if (item.osusumeBuhinList && item.osusumeBuhinList.length == 1) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else if (item.buhinList && item.buhinList.length == 1) {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
      } else {
        item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
        if (item.buhinList && item.buhinList.length > 0) {
          item.buhinList = new Array();
        }
        if (item.osusumeBuhinList && item.osusumeBuhinList.length > 0) {
          item.osusumeBuhinList = new Array();
        }
      }
      this.service.setInspectResultRecomend2(item.inspectResult, item);
      this.changeOsusumeStatus(item);
    });
    this.saveOsusumeCurrentData();
  }

  hideAll() {
    if (this.isShowAll(0)) {
      return;
    }
    this.currentData.forEach((item :any, i) => {
      if (item.isInspectDuplicate == 0) {
        item.osusumeIsShow = 0;
        this.service.setInspectResultRecomend2(item.inspectResult, item);
        this.deleteAlManualBuhin(item);
        this.service.deletAllBuhinInSebi([item]);
      }
    });
    this.saveOsusumeCurrentData();
  }

  saveOsusumeCurrentData() {
    this.currentData.forEach(seibi => {
      seibi.isSaving = true;
    });
    let objForSave = util.deepCopy(this.currentData);
    if (this.data.jizen[this.activeCategory].recommend && this.data.jizen[this.activeCategory].recommend[this.activeSubCategory]) {
      let id = this.data.jizen[this.activeCategory].recommend[this.activeSubCategory]
        .sknRecommendInspectCategoryId;
      objForSave.forEach((obj: any) => {
        delete obj.status;
        delete obj.showWork;
        delete obj.isSaving;
      });
      /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [START] */
      const data = this.getObjForSaveOsusume(objForSave);
      /**
      const data = {
        isSocket: 1,
        jizen: [
          {
            recommend: [
              {
                sknRecommendInspectCategoryId: id,
                sknRecommendInspectCategoryNm: this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].sknRecommendInspectCategoryNm,
                kingakuZk: this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].kingakuZk,
                kingakuZn: this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].kingakuZn,
                subItems: objForSave
              }
            ]
          , sknInspectCategoryId: this.data.jizen[this.activeCategory] ? this.data.jizen[this.activeCategory].sknInspectCategoryId : ''
          }
        ]
      };
      */
      /** 2023-07-15 sh #8391(BQR1109) fix bug. manual seibi does not add. [END] */
      this.saveAndUpdateData(data, true);
    }
  }
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
  seibiNm: string = "";
  kouchinZn: any = null;
  kouchinZk: any = null;
  addcurrentData() {
    if (this.seibiNm.length > 0) {
      this.arrStatus.push(InspectButtonStatus.COMPLETED);
      this.saveManualItem();
    }
  }
  saveManualItem() {
    this.isSaving = true;
    let manualItems: any = [];
    let manualItem = {
      sknUketsukeExtendsId: this.uketsukeExtendsId + ''
      , seibiNm: this.seibiNm
      , kouchinZn: this.kouchinZn
      , kouchinZk: this.kouchinZk
      , buhinSelected: STATUS_SELECT_WORK_BUHIN.Done
      , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
      , sknRecommendInspectCategoryId: this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].sknRecommendInspectCategoryId
      , osusumeIsShow: 1 // add
      , buhinList: []
      , manualBuhinList: []
      , osusumeBuhinList: []
      , sknInspectCategoryId: this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems[0].sknRecommendInspectCategoryId
    }
    manualItems.push(manualItem);
    const data = {
      isSocket: 1,
      recommend: [
        {
          subItems: []
          , manualItems: manualItems
        }
      ]
    };
    this.reqService.saveJizenInspectRecommendManual(data).then(
      (res: any) => {
        if (res.status == 200 && res.body) {
          let d: any = {
            sknUketsukeExtendsId: this.uketsukeExtendsId
            , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
            , branchId: '0'
            , inspectResult: 0
            , isNumber: 0
            , inspectValue: 0
            , seibiId: res.body
            , sknInspectCommentId: 0
            , inspectValueList: []
            , inspectValueViewType: 0
            , koukanMeyasuTime: 0
            , sknRecommendInspecSeibiId: null
            , sknRecommendInspecSeibiNm: this.seibiNm
            , sknInspectSeibiDetailId: 0
            , isInspectDuplicate: 0
            , kingaku: this.kouchinZn
            , kouchinZn: this.kouchinZn
            , buhinSelected: STATUS_SELECT_WORK_BUHIN.Done
            , buhinList: []
            , manualBuhinList: []
            , osusumeIsShow: 1
            , sknRecommendInspectCategoryId: this.data.recommend ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId ? this.data.recommend[this.activeCategory].sknRecommendInspectCategoryId : 0 : 0
            , osusumeBuhinList: []
            , isDoTenken: 0
            , rowNum: this.currentData.length
            , isSaving: false
            , status: InspectButtonStatus.COMPLETED
          }
          this.currentData.push(d);
          if (this.data && this.data.jizen[this.activeCategory].recommend
            && this.data.jizen[this.activeCategory].recommend.length > 0
            && this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems
            && this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems.length > 0) {
            this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems.push(d);
            console.log(this.data.jizen[this.activeCategory].recommend[this.activeSubCategory].subItems);
          }
          this.seibiNm = "";
          this.kouchinZn = null;
          this.kingakuFlg = false;
        }
        this.isSaving = false;
      },
      error => {
        console.error("error", error);
        this.isSaving = false;
      }
    );
  }
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
}
